module.exports = __webpack_public_path__ + "static/img/home.ee6c332b.svg";